/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ClimateEntryCancelSTokenPost$Params {
  sToken: string;
}

export function climateEntryCancelSTokenPost(http: HttpClient, rootUrl: string, params: ClimateEntryCancelSTokenPost$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, climateEntryCancelSTokenPost.PATH, 'post');
  if (params) {
    rb.path('sToken', params.sToken, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

climateEntryCancelSTokenPost.PATH = '/climateEntry/cancel/{sToken}';
